/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Guide_What_Is_JsonInputs */

const en_sidebar_guide_what_is_json = /** @type {(inputs: Sidebar_Guide_What_Is_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is JSON?`)
};

const ko_sidebar_guide_what_is_json = /** @type {(inputs: Sidebar_Guide_What_Is_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON이란?`)
};

const ja_sidebar_guide_what_is_json = /** @type {(inputs: Sidebar_Guide_What_Is_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONとは？`)
};

/**
* | output |
* | --- |
* | "What is JSON?" |
*
* @param {Sidebar_Guide_What_Is_JsonInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_guide_what_is_json = /** @type {((inputs?: Sidebar_Guide_What_Is_JsonInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Guide_What_Is_JsonInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_guide_what_is_json(inputs)
	if (locale === "ko") return ko_sidebar_guide_what_is_json(inputs)
	return ja_sidebar_guide_what_is_json(inputs)
});